import React from "react";
import CustomerProfileSection from "./CustomerProfileSection";
import { isBiometricNativeRuntime } from "../../utils/biometricLogin";
export default function CustomerAccountActions({
  activeSection = "all",
  viewingOther,
  role,
  deleteStep,
  setDeleteStep,
  handleRequestDeletion,
  exportStep,
  handleRequestExport,
  bioAvailable,
  bioReason,
  bioLoading,
  refreshBiometricState,
  bioLabel,
  bioEnabled,
  disableBiometricLogin,
}) {
  if (viewingOther) return null;
  return (
    <div className="prf-account-actions">
      {!viewingOther && role !== "admin" && (
        <div className="prf-slot" hidden={activeSection !== "all" && activeSection !== "privacy"}>
          <CustomerProfileSection
            title="Privacy e dati"
            headingClassName="prf-sum--export"
          >
            <div className="prf-body">
              <div className="prf-export-zone">
                <p className="prf-danger-desc">
                  Hai diritto a ricevere una copia di tutti i tuoi dati
                  personali in formato leggibile (GDPR Art. 20). Invieremo un
                  file JSON al tuo indirizzo email con profilo, indirizzi,
                  ordini, wallet, abbonamenti e promozioni.
                </p>

                {exportStep === "idle" && (
                  <div className="prf-actions prf-actions--start">
                    <button
                      type="button"
                      className="prf-btn prf-btn--export"
                      onClick={handleRequestExport}
                    >
                      Esporta i miei dati
                    </button>
                  </div>
                )}

                {exportStep === "sending" && (
                  <p className="prf-muted">Invio in corso…</p>
                )}

                {exportStep === "sent" && (
                  <div className="prf-export-confirm">
                    <p className="prf-export-note">
                      Richiesta inviata. Riceverai i tuoi dati via email non
                      appena il nostro team li avrà elaborati.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </CustomerProfileSection>
        </div>
      )}

      {!viewingOther && isBiometricNativeRuntime() && (
        <div className="prf-slot prf-slot--security" hidden={activeSection !== "all" && activeSection !== "security"}>
          <CustomerProfileSection title="Accesso rapido" headingClassName="">
            <div className="prf-body">
              {!bioAvailable ? (
                <>
                  <p className="prf-muted">
                    La biometria non risulta disponibile su questo dispositivo.
                  </p>
                  {!!bioReason && (
                    <p className="prf-muted" style={{ marginTop: 6 }}>
                      Motivo: {bioReason}
                    </p>
                  )}
                  <div className="prf-actions prf-actions--start">
                    <button
                      type="button"
                      className="prf-btn"
                      onClick={refreshBiometricState}
                      disabled={bioLoading}
                    >
                      {bioLoading ? "Verifica..." : "Ricarica stato"}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="prf-bio-card">
                    <div className="prf-bio-row">
                      <div>
                        <div className="prf-bio-title">{bioLabel}</div>
                        <div className="prf-bio-subtitle">
                          Usa {bioLabel} per accedere più rapidamente
                          all&apos;app.
                        </div>
                      </div>

                      <span
                        className={`prf-tag ${
                          bioEnabled ? "prf-tag--ok" : "prf-tag--muted"
                        }`}
                      >
                        {bioEnabled ? "Attivo" : "Non attivo"}
                      </span>
                    </div>

                    <div className="prf-bio-hint">
                      L&apos;accesso rapido si attiva automaticamente dopo un
                      login normale riuscito nell&apos;app mobile.
                    </div>
                  </div>

                  <div className="prf-actions prf-actions--start">
                    <button
                      type="button"
                      className="prf-btn"
                      onClick={refreshBiometricState}
                      disabled={bioLoading}
                    >
                      {bioLoading ? "Aggiorno..." : "Aggiorna stato"}
                    </button>

                    <button
                      type="button"
                      className="prf-btn prf-btn--danger"
                      onClick={disableBiometricLogin}
                      disabled={bioLoading || !bioEnabled}
                    >
                      Disattiva accesso rapido
                    </button>
                  </div>
                </>
              )}
            </div>
          </CustomerProfileSection>
        </div>
      )}
      {!viewingOther && role !== "admin" && (
        <div className="prf-slot prf-slot--danger" hidden={activeSection !== "all" && activeSection !== "privacy"}>
          <CustomerProfileSection
            title="Azioni sensibili"
            headingClassName="prf-sum--danger"
          >
            <div className="prf-body">
              <div className="prf-danger-zone">
                <p className="prf-danger-desc">
                  Puoi richiedere la cancellazione del tuo account. La richiesta
                  verrà esaminata dal nostro team e i tuoi dati
                  personali verranno rimossi.
                </p>

                {deleteStep === "idle" && (
                  <div className="prf-actions prf-actions--start">
                    <button
                      type="button"
                      className="prf-btn prf-btn--danger"
                      onClick={() => setDeleteStep("confirm")}
                    >
                      Richiedi cancellazione account
                    </button>
                  </div>
                )}

                {deleteStep === "confirm" && (
                  <div className="prf-danger-confirm">
                    <p className="prf-danger-warn">
                      Vuoi inviare la richiesta? Il nostro team la esaminerà
                      entro breve e ti contatterà via email. La cancellazione
                      effettiva avviene solo dopo l&apos;approvazione da parte
                      dell&apos;admin.
                    </p>
                    <div className="prf-actions">
                      <button
                        type="button"
                        className="prf-btn"
                        onClick={() => setDeleteStep("idle")}
                      >
                        Annulla
                      </button>
                      <button
                        type="button"
                        className="prf-btn prf-btn--danger"
                        onClick={handleRequestDeletion}
                      >
                        Sì, invia richiesta
                      </button>
                    </div>
                  </div>
                )}

                {deleteStep === "sending" && (
                  <p className="prf-muted">Invio in corso…</p>
                )}

                {deleteStep === "sent" && (
                  <div className="prf-danger-confirm">
                    <p className="prf-danger-warn" style={{ color: "#1d4ed8" }}>
                      Richiesta inviata. Il nostro team la esaminerà a breve e
                      riceverai una email di risposta.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </CustomerProfileSection>
        </div>
      )}
    </div>
  );
}
